import HomeButton from "../../components/home-button/Index";
import Space from "../../components/space/Index";

import About from "../about/Index";
import Hero from "../hero/Index";
import Projects from "../projects/Index";

const Home = () => {
  return (
    <>
      <Hero />
      <Projects />
      <About />
      <Space />
      <HomeButton />
    </>
  );
};

export default Home;
